import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const CheckMarkIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
    >
      <path d='m9 16.2-3.5-3.5a.984.984 0 0 0-1.4 0 .984.984 0 0 0 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7a.984.984 0 0 0 0-1.4.984.984 0 0 0-1.4 0z' />
    </svg>
  )
);
